/*actions for recipes reducer*/
export const SET_SEARCH_VALUE = 'SET_SEARCH_VALUE';
export const FETCH_RECIPES_START = 'FETCH_RECIPES_START';
export const FETCH_RECIPES_SUCCESS = 'FETCH_RECIPES_SUCCESS';
export const FETCH_RECIPES_FAILED = 'FETCH_RECIPES_FAILED';


/*actions for meal planner reducer*/
export const RESET_MEAL_PLANNER = 'RESET_MEAL_PLANNER';
export const SET_CALORIES = 'SET_CALORIES';
export const SET_DIET_TYPE = 'SET_DIET_TYPE';
export const SET_STATUS = 'SET_STATUS';
export const SET_LOADER = 'SET_LOADER';
export const FETCH_DIET_START = 'FETCH_DIET_START';
export const FETCH_DIET_SUCCESS = 'FETCH_DIET_SUCCESS';
export const FETCH_DIET_FAILED = 'FETCH_DIET_FAILED';
export const SAVE_DIET_START = 'SAVE_DIET_START';
export const SAVE_DIET_SUCCESS = 'SAVE_DIET_SUCCESS';
export const SAVE_DIET_FAILED = 'SAVE_DIET_FAILED';

/*actions for auth reducer*/
export const SET_IS_SIGN_UP = 'SET_IS_SIGN_UP';
export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const AUTH_FAILED = 'AUTH_FAILED';
export const LOGOUT_USER = 'LOGOUT_USER';


/*actions for directions reducer*/
export const FETCH_VIEWED_RECIPE_START = 'FETCH_VIEWED_RECIPE_START';
export const FETCH_VIEWED_RECIPE_SUCCESS = 'FETCH_VIEWED_RECIPE_SUCCESS';
export const FETCH_VIEWED_RECIPE_FAILED = 'FETCH_VIEWED_RECIPE_FAILED';

/*actions for profile reducer*/
export const SET_USER_DATA = 'SET_USER_DATA'
export const UPDATE_IMAGE = 'UPDATE_IMAGE';
export const SET_USER_PHOTO = 'SET_USER_PHOTO';
export const SET_USER_DIET = 'SET_USER_DIET';
export const SET_USER_POSTS = 'SET_USER_POSTS';

/* actions for all posts reducer */
export const START_FETCHING = 'START_FETCHING';
export const SET_POSTS = 'SET_POSTS';
export const SET_ERROR = 'SET_ERROR';



